import { useEffect, useState } from "react";
import { motion, AnimatePresence } from 'framer-motion';

const images = [
    "/customers/pbhub.png",
    "/customers/neko.svg",
    "/customers/goon.png",
    "/customers/mxcc.svg",
    "/customers/angelo.webp",
    "/customers/catdump.png"
];

// Animation variants 
const getTestinomialCardVariant = (i) => {
    // return {}
    return { hidden: { opacity: 0, y: 40+(i*40) }, visible: { opacity: 1, y: 0, transition: { duration: 0.5 } } };
}

export const TestinomialSection = () => {

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    return (
        <section className="customer-section">
            <div className="inner">

                <div className="col">
                    <h1 className="impact-hdr">Testinomials</h1>
                </div>

                <div className="col">
                    <motion.div
                        initial="hidden"
                        variants={getTestinomialCardVariant(0)}
                        whileInView={"visible"}
                        className="review">
                        <p className="review-text">I have always received #1 quality products from this company. Their consistent dedication to delivering high-quality items is impressive and greatly appreciated.</p>
                        <p>- Andy L.</p>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        variants={getTestinomialCardVariant(1)}
                        whileInView={"visible"}
                        className="review">
                        <p className="review-text">Fully satisfied, finished before the deadline, Contact team was great, do recommend for any project.</p>
                        <p>- Harrison Terence W.</p>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        variants={getTestinomialCardVariant(2)}
                        whileInView={"visible"}
                        className="review">
                        <p className="review-text">The team is very good & did the project in record time and very well, we are discussing to work further with them.</p>
                        <p>- Perumal M.</p>
                    </motion.div>
                    <motion.div
                        initial="hidden"
                        variants={getTestinomialCardVariant(3)}
                        whileInView={"visible"}
                        className="review">
                        <p className="review-text">It was really great to work with them, they gave me what i wanted. Great experience.</p>
                        <p>- Leo F.</p>
                    </motion.div>
                </div>

                <div className="col">
                    <div className="client-logo-scroll">
                        <AnimatePresence>
                            <motion.div
                                key={currentIndex}
                                initial={{ x: '100%' }}
                                animate={{ x: '0%' }}
                                exit={{ x: '-100%' }}
                                transition={{ duration: 0.5 }}
                                className="client-logo-image"
                            >
                                <img src={images[currentIndex]} alt={`Client Logo ${currentIndex}`} />
                            </motion.div>
                        </AnimatePresence>
                    </div>
                </div>

            </div>
        </section>
    );
}